import type { CreateSetup, Setup } from '@here/api'

export function isSetupLogScale(setup: Setup | CreateSetup) {
	return setup.duration === 'multiday'
}
